<template>
  <div class="preview mt-5"
       v-if="selectedArticle && articleReplacements && articleReplacements.length > 0">
    <h5>
      Artykuł {{ selectedArticle.catalog_number }} - {{ selectedArticle.model }} <br>
      był zamiennikiem dla
    </h5>

    <div class="table-responsive mt-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Zapotrzebowanie projektowe</th>
          <th>Nr artykuł</th>
          <th>Nr Katalogowy</th>
          <th>Model</th>
          <th>Opis</th>
          <th>Link</th>
          <th>Utworzony przez</th>
          <th>Data utworzenia</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="replacement in articleReplacements" :key="replacement.id">
          <td>
            <a style="color:#0d6efd"
               :href="route('requiredProjectItems.index', {id:replacement.required_project_items_id})" target="_blank">
              {{ replacement.required_project_items_id }}
            </a>
          </td>
          <td>{{ replacement.origin_article.id }}</td>
          <td>{{ replacement.origin_article.catalog_number }}</td>
          <td>{{ replacement.origin_article.model }}</td>
          <td>{{ replacement.origin_article.description }}</td>
          <td><a :href="replacement.origin_article.link" target="_blank">{{ replacement.origin_article.link }}</a>
          </td>
          <td>{{ replacement.replacement_created_by.first_name ?? '' }}
            {{ replacement.replacement_created_by.last_name ?? '' }}
          </td>
          <td>{{ formatDate(replacement.created_at) }}</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  props: {
    selectedArticle: Object
  },

  data() {
    return {
      articleReplacements: [],
    }
  },

  watch: {
    selectedArticle: {
      immediate: true,
      handler(newArticle) {
        if (newArticle) {
          this.getHistoryData(newArticle.id);
        }
      }
    }
  },

  methods: {
    getHistoryData() {
      axios.get(route('articles.getReplacementHistory', {article: this.selectedArticle.id})).then(response => {
        this.articleReplacements = response.data.replacements;
      }).catch(error => {
        console.log(error);
      });
    },


    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są od 0 do 11, więc dodajemy 1
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    }
  }
}
</script>

<style scoped>

</style>